var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.876 19.757"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.223 3.12H3.12A3.121 3.121 0 000 6.239v10.4a3.121 3.121 0 003.12 3.12h16.637a3.121 3.121 0 003.12-3.12v-10.4a3.121 3.121 0 00-3.12-3.12h-1.691L16.73 1.341A2.079 2.079 0 0014.785 0H8.091a2.081 2.081 0 00-1.978 1.436l-.89 1.684zm6.215 2.6a5.2 5.2 0 105.2 5.2 5.2 5.2 0 00-5.2-5.201zm0 2.08a3.12 3.12 0 11-3.12 3.12 3.121 3.121 0 013.12-3.12z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "018a61d5d5d69e667ea56fa97821b9d8.svg";
export { SvgCamera as ReactComponent };